import { NgModule, InjectionToken } from '@angular/core';
import { MediaUploaderComponent } from './components/media-uploader/media-uploader.component';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { MediaListComponent } from './components/media-list/media-list.component';
import { MediaItemComponent } from './components/media-item/media-item.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DragDirective } from './directives/dragzone/drag.directive';

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => localStorage
});

@NgModule({
  declarations: [
    MediaUploaderComponent, 
    DropzoneComponent, 
    MediaListComponent, 
    MediaItemComponent, 
    DragDirective
  ],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [MediaUploaderComponent]
})
export class MediaUploaderModule {}
